export default class FunctionsClientUnauthorizedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "FunctionsClientUnauthorizedError";
  }
}
